import React from "react";
import CompensationChart from "./Chart";
import Box from "../../../../components/Box/Box";
import { Col, Row } from "antd";
import HeadingSubHeading from "../../../../components/ViewHeading/HeadingSubHeading";
import { MasterConfigs } from "../../../../interfaces/entity";
import ReusableTable from "../../../../components/TableComponent";

const CompensationPlaning = () => {

    const config: MasterConfigs = {
        api: () => '/compensation',
        title: 'Compensation Planning',
        modalTitle: (text) => `Add`,
        getColumns: () => [
            {
                title: 'Upcoming Months',
                dataIndex: 'upcomingMonths',
                key: 'upcomingMonths',
                render: (text) => text
            }, {
                title: 'Estimated Employee Cost',
                dataIndex: 'estimatedEmployeeCost',
                key: 'estimatedEmployeeCost',
                render: (text) => text
            }, {
                title: 'Compensation Cost',
                dataIndex: 'compensationCost',
                key: 'compensationCost',
                render: (text) => text
            }, {
                title: 'Fix Pay',
                dataIndex: 'fixPay',
                key: 'fixPay',
                render: (text) => text
            }, {
                title: 'Bonus',
                dataIndex: 'bonus',
                key: 'bonus',
                render: (text) => text
            }, {
                title: 'Others',
                dataIndex: 'others',
                key: 'others',
                render: (text) => text
            }, {
                title: 'Final Cost',
                dataIndex: 'finalCost',
                key: 'finalCost',
                render: (text) => text
            }
        ]
    }




    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <HeadingSubHeading titleProps={{ level: 5 }} title="Compensation Summary" />
            </Col>
            <Col span={24}>
                <Box title="Compensation Cost - Upcoming Months">
                    <CompensationChart />
                </Box>
            </Col>
            <Col span={24}>
                <ReusableTable config={config} />
            </Col>
        </Row>
    );
}

export default CompensationPlaning;